import { Component, EventEmitter, Output } from '@angular/core';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { InternalSettings, PermissionList } from '../../services/internal-settings/internal-settings.interface';
import { hasOnePermission, InternalSettingsService } from '../../services/internal-settings/internal-settings.service';
import { PersonalFinanceManagementService } from '../../services/personal-finance-management/personal-finance-management.service';
import { FinanceTips } from '../../services/personal-finance-management/personal-finance-management-bean';
import { PersonalFinanceManagementDialogService } from './personal-finance-management-dialog.service';
import { Router } from '@angular/router';
import { ResponsiveDesignService } from '../../services/responsive-design/responsive-design.service';
import { NavigationService } from 'src/app/system/utility/navigation.service';

@Component({
    selector: 'app-personal-finance-management-header',
    templateUrl: './personal-finance-management-header.component.html',
    styleUrl: './personal-finance-management-header.component.less',
    standalone: false
})
export class PersonalFinanceManagementHeaderComponent {

  @Output() insightClick = new EventEmitter<void>();

  destroy$: Subject<void> = new Subject();
  UIUtilityService: any= UIUtilityService;
  internalSettings!: InternalSettings;
  externalSettings!: ExternalSettings;
  hasPermission : boolean = false 

  constructor(
    private router: Router,
    private srvIS: InternalSettingsService, 
    private srvES: ExternalSettingsService,
    private service: PersonalFinanceManagementService,
    private srvTipsDialog: PersonalFinanceManagementDialogService,
    protected srvRpDesign: ResponsiveDesignService,
  )
  {
    combineLatest([
      this.srvIS.getCurrentSettings(),
      this.srvES.externalSettings$,
    ]).pipe(takeUntil(this.destroy$))
    .subscribe(([internalSettings, externalSettings]) => {
      this.internalSettings = internalSettings;
      this.externalSettings = externalSettings;

      this.initialize();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private initialize() {

    let isModuleEnabled = this.externalSettings.globalVariables.isModuleEnabledPersonalFinanceManagement; 
    if (!isModuleEnabled) return;

    this.hasPermission = hasOnePermission([ PermissionList.MOBILEARTH_ACCESS_PFM_INSIGHT], this.internalSettings.permissions!);
    
    if (this.hasPermission) {
      this.service.getTips().subscribe((res : FinanceTips) => {
        if (res != null && res.tips?.length > 0) {
          if (NavigationService.isOnDashboardPage(this.router)) {
            this.srvTipsDialog.showDialog(res, this.externalSettings);
          }
        }
      });
    }
  }

  // Navigate to Insight
  onInsightClick(_event: any) {
    _event.stopPropagation();
    _event.preventDefault();
    if (this.srvRpDesign.isMobileView() || this.srvRpDesign.isTabletApp()) {
      this.insightClick.emit();
    }
    this.router.navigateByUrl("/personal-finance-management-landing");
  }

}
